import { render, staticRenderFns } from "./WholesaleActivatePage.vue?vue&type=template&id=5a2ad51a&scoped=true"
import script from "./WholesaleActivatePage.vue?vue&type=script&lang=js"
export * from "./WholesaleActivatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ad51a",
  null
  
)

export default component.exports